<ds-breadcrumb>
  <ds-breadcrumb-item>
    <a href="#">{{ plantName }}</a>
  </ds-breadcrumb-item>
  <ds-breadcrumb-item>
    <a href="#">{{ plantCode }}</a>
  </ds-breadcrumb-item>
</ds-breadcrumb>
